import { IValidationInputs } from './interfaces';

export const ValidationInputs = ({ text }: IValidationInputs) => {
  return /^[0-9]*$/.test(text);
};

export const InputChanged = (set: any) => (e: any) => {
  if (ValidationInputs({ text: e.target.value })) {
    set(e.target.value);
  }
};
